/**
 * The positive integer `text` writes in plain decimal digits, the way the API writes an id: a person's in an access
 * token's `sub`, a company's in an address. Null for anything else: a value that is not a string (a query key given
 * twice arrives as a list), an empty one, a sign, a leading zero, a fraction, an exponent, a space, or more digits than
 * a number holds exactly.
 */
export function positiveInteger(text: unknown): number | null {
    if (typeof text !== 'string' || !/^[1-9]\d*$/.test(text)) return null;

    const integer = Number(text);
    return Number.isSafeInteger(integer) ? integer : null;
}
